module.exports = __webpack_public_path__ + "media/images/charts/PemegangSaham-PieChart3-3fec3cc3d31a1ea7744ccce3dc93d343.jpg";